import "clsx";
import { b as attr, e as escape_html, p as pop, a as push, k as ensure_array_like } from "../../../chunks/index2.js";
import { g as getCartState, s as setCartState } from "../../../chunks/Cart.svelte.js";
import { g as getToastState } from "../../../chunks/Toast.svelte.js";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/state.svelte.js";
function CartItem($$payload, $$props) {
  push();
  const { item } = $$props;
  getCartState();
  getToastState();
  const hasDiscount = !!item.product.discountedPrice;
  const finalUnit = hasDiscount ? item.product.discountedPrice : item.product.price;
  const appliedPromotion = item.product.appliedPromotion || null;
  const discountBadge = (() => {
    if (!appliedPromotion) return "";
    if (appliedPromotion.discountType === "PERCENT") return `${appliedPromotion.discountValue}% off`;
    const amt = appliedPromotion.discountValue;
    const pct = Math.round(amt / item.product.price * 100);
    return `Save KES ${amt.toLocaleString()}${pct ? ` (${pct}% )` : ""}`;
  })();
  $$payload.out.push(`<div class="border-fadeblack flex items-center justify-between border-b py-2"><div class="flex items-center"><img${attr("src", item.product.Image[0]?.url || "/coat-of-arms.jpg")} alt="Product" class="mr-4 size-12 rounded-sm object-cover"/> <div><h4>${escape_html(item.product.name)}</h4> `);
  if (hasDiscount) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="text-sm"><span class="mr-1 text-gray-400 line-through">KES ${escape_html(item.product.price.toLocaleString())}</span> <span class="text-primary font-semibold">KES ${escape_html(finalUnit.toLocaleString())}</span></div> `);
    if (discountBadge) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<span class="bg-primary/10 text-primary mt-0.5 inline-block rounded px-2 py-0.5 text-[11px] font-medium">${escape_html(discountBadge)}</span>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]-->`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<span class="text-sm">KES ${escape_html(item.product.price.toLocaleString())} each</span>`);
  }
  $$payload.out.push(`<!--]--> <div class="mt-0.5 text-xs text-gray-500">Subtotal: KES ${escape_html((finalUnit * item.quantity).toLocaleString())}</div></div></div> <div class="flex items-center"><button class="rounded-sm p-1 hover:bg-gray-200" aria-label="Subtract 1 from quantity">-</button> <span class="p-1">${escape_html(item.quantity)}</span> <button class="rounded-sm p-1 hover:bg-gray-200" aria-label="Add 1 to quantity">+</button> <button class="ml-4 rounded-sm p-1 hover:bg-red-200">🗑️</button></div></div>`);
  pop();
}
function Navbar($$payload, $$props) {
  push();
  let { user, cart } = $$props;
  $$payload.out.push(`<header class="bg-fadeblack relative flex items-center justify-between p-2 text-white"><button class="rounded-md p-2 transition-colors hover:bg-white/10 md:hidden" aria-label="Toggle menu"><i class="bi bi-list text-xl"></i></button> <nav class="hidden items-center md:flex"><ul class="flex"><li class="hover:text-secondary mx-4 transition-colors"><a href="/product">Products</a></li> `);
  if (user) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<li class="hover:text-secondary mx-4 transition-colors"><a href="/legislation">Legislation Status Report</a></li>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <li class="hover:text-secondary mx-4 transition-colors"><a href="/subscription">Subscription</a></li> `);
  if (user) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<li class="hover:text-secondary mx-4 transition-colors"><a href="/purchases">Purchases</a></li>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></ul></nav> <div class="flex items-center">`);
  if (user) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<a class="hover:text-secondary mx-4 hidden transition-colors md:block" href="/profile">My Account</a>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <button class="hover:border-secondary rounded-md p-1 transition-colors hover:border-b">My Cart: ${escape_html(cart.cartStats.quantity)}</button> `);
  if (user) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<button class="hover:text-secondary mx-4 transition-colors">Logout</button>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<div class="mx-4 hidden transition-colors md:block"><a href="/login" class="hover:text-secondary">Login</a> or <a href="/register" class="hover:text-secondary">Register</a></div>`);
  }
  $$payload.out.push(`<!--]--></div></header> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  if (cart.cartopen) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="absolute top-28 right-0 rounded-md z-10 bg-white shadow-lg"><div class="fixed inset-0" aria-hidden="true"></div> <div class="relative p-4"><h2 class="text-lg font-bold">Your cart</h2> <button class="absolute top-3 right-2 rounded-full p-1 font-semibold hover:bg-gray-100" aria-label="close cart">X</button> `);
    if (cart.cartStats.quantity) {
      $$payload.out.push("<!--[-->");
      const each_array = ensure_array_like(cart.cartItems);
      $$payload.out.push(`<!--[-->`);
      for (let i = 0, $$length = each_array.length; i < $$length; i++) {
        let item = each_array[i];
        CartItem($$payload, { item });
      }
      $$payload.out.push(`<!--]--> <div class="mt-3"><p class="font-semibold">Total: ${escape_html(cart.cartStats.total.toFixed(2))}</p></div> <a${attr("href", user ? "/checkout" : "/login")}><button class="hover:bg-primary rounded-md border border-gray-300 px-2 py-1 transition-colors hover:text-white">Proceed to checkout</button></a>`);
    } else {
      $$payload.out.push("<!--[!-->");
      $$payload.out.push(`<div><i class="text-sm">Your cart is empty</i></div>`);
    }
    $$payload.out.push(`<!--]--></div></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
function _layout($$payload, $$props) {
  push();
  const { children, data } = $$props;
  const user = data.user;
  data.isSubscribed || false;
  const cart = setCartState(data.cartItems);
  $$payload.out.push(`<div class="m-5"><a href="/"><img src="/kLawLogo.png" alt="logo" class="h-10 md:h-12 lg:h-20"/></a></div> `);
  Navbar($$payload, { user, cart });
  $$payload.out.push(`<!----> <div class="min-h-screen bg-gray-50">`);
  children?.($$payload);
  $$payload.out.push(`<!----></div>`);
  pop();
}
export {
  _layout as default
};
